import React, { useState } from 'react';
import PropTypes from 'prop-types';

import FontAwesome from 'utils/FA';
import DelayedJob from './DelayedJob';
import { queueTitle } from './helpers';


/**
 * A table representing a single delayed jobs queue
 */

const JobsTable = ({
  jobs,
  queue
}) => {
  const [shown, setShown] = useState(true);

  return (
    <div>
      <a name={queue} onClick={() => setShown(!shown)}>
        <h3 className='delayed-jobs-table-header'>
          {`${queueTitle(queue)} Jobs`}
          &nbsp;
          <FontAwesome name={`caret-${shown ? 'down' : 'right'}`} />
        </h3>
      </a>

      {
        shown && (
          <table className='table'>
            <thead>
              <tr>
                <th>Status</th>
                <th>Priority</th>
                <th>Created at</th>
                <th>Run At</th>
                <th>Class</th>
                <th>Type</th>
                <th>Customer</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {
                jobs.length > 0
                  ? jobs.map((job) => <DelayedJob job={job} key={job.id} />)
                  : (
                    <tr>
                      <td colSpan='8'>The are no delayed jobs in this queue.</td>
                    </tr>
                  )
              }
            </tbody>
          </table>
        )
      }
    </div>
  );
};

JobsTable.propTypes = {
  /** A list of delayed jobs */
  jobs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })),

  /** The name of the delayed jobs queue */
  queue: PropTypes.string
};

JobsTable.defaultProps = {
  jobs: [],
  queue: ''
};

export default JobsTable;
